/**
 * Puts operations into the order of the operations tab of the routing: by operationNumber, and
 * by list position for an operation without a number (the operations grid sorts the same way).
 * Returns a new array; the input stays unchanged.
 */
export function sortByOperationNumber<T extends { operationNumber?: number | null }>(operations: T[]): T[] {
  return operations
    .map((operation, index) => ({ operation, order: operation.operationNumber ?? index + 1 }))
    .sort((a, b) => a.order - b.order)
    .map(({ operation }) => operation);
}
